var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row justify-content-center" }, [
    _c("div", { staticClass: "col-md-12" }, [
      _c("div", { staticClass: "card card-default" }, [
        _c(
          "div",
          {
            staticClass:
              "pb-1 d-flex border-bottom card-header align-items-center p-0 m-1",
          },
          [
            _c("h3", { staticClass: "text-bold-700 mb-0" }, [
              _c("i", { staticClass: "feather icon-send" }),
              _vm._v(" " + _vm._s(_vm.__("chat.inbox"))),
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-primary",
                attrs: { href: "/member/chat" },
              },
              [
                _c("i", { staticClass: "fa fa-envelope-o" }),
                _vm._v(
                  " " +
                    _vm._s(_vm.__("chat.compose_new_message")) +
                    "\n                    "
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c(
              "ul",
              { staticClass: "list-group" },
              _vm._l(_vm.messages, function (message) {
                return message.chat_type === "single"
                  ? _c(
                      "li",
                      { key: message.id, staticClass: "list-group-item" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex align-items-center",
                            on: {
                              click: function ($event) {
                                return _vm.goToChat(message)
                              },
                            },
                          },
                          [
                            message.chat_type === "single"
                              ? _c("div", [
                                  _c("img", {
                                    staticClass: "round",
                                    attrs: {
                                      src:
                                        message.second_party.user_image !== null
                                          ? message.second_party.user_image
                                          : "/images/avatar.png",
                                      alt: "avatar",
                                      height: "40",
                                      width: "40",
                                    },
                                  }),
                                ])
                              : _c("div", [
                                  _c("img", {
                                    staticClass: "round",
                                    attrs: {
                                      src: "/images/Group-icon.png",
                                      alt: "avatar",
                                      height: "40",
                                      width: "40",
                                    },
                                  }),
                                ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "ml-05" }, [
                              _c("span", { staticClass: "h4" }, [
                                _vm._v(
                                  "  " + _vm._s(message.second_party.full_name)
                                ),
                              ]),
                              _vm._v(" "),
                              message.chat_type === "single"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "font-small-2 text-bold-700 text-light",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(message.second_party.position) +
                                          " |\n                                        " +
                                          _vm._s(
                                            message.second_party.organisation
                                          ) +
                                          "\n                                    "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              message.chat_type === "single"
                                ? _c("span", {
                                    staticClass:
                                      "text-muted mt-1 font-small-3 d-block",
                                    domProps: {
                                      innerHTML: _vm._s(message.message),
                                    },
                                  })
                                : _c("span", {
                                    staticClass:
                                      "text-muted mt-1 font-small-3 d-block",
                                    domProps: {
                                      innerHTML: _vm._s(message.message),
                                    },
                                  }),
                            ]),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "pl-1 ml-auto font-small-3",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.showDate(message.created)
                                ),
                              },
                            }),
                          ]
                        ),
                      ]
                    )
                  : _vm._e()
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "infinite-loading",
              {
                attrs: { spinner: "spiral", identifier: _vm.infiniteId },
                on: { infinite: _vm.infiniteHandler },
              },
              [
                _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }),
                _vm._v(" "),
                _c("div", {
                  attrs: { slot: "no-results" },
                  slot: "no-results",
                }),
              ]
            ),
            _vm._v(" "),
            _vm.messages.length === 0
              ? _c(
                  "div",
                  {
                    staticClass:
                      "mt-1  mb-1 text-center text-bold-600 text-light",
                  },
                  [_vm._v(_vm._s(_vm.__("chat.no_messages")))]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }